export const transactionReportCode = {
    "curl": {
      "request": `curl -X 'GET'
'https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/transactionReport?StartDate=2023-06-28T00%3A03%3A18.265Z&EndDate=2023-06-28T05%3A03%3A18.265Z'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'`
    },
    "java": {
      "request": `import java.io.BufferedReader;
import java.io.InputStreamReader;
import java.net.HttpURLConnection;
import java.net.URL;
      
public class Main {
    public static void main(String[] args) {
        try {
            String url = "https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/transactionReport?StartDate=2023-06-28T00%3A03%3A18.265Z&EndDate=2023-06-28T05%3A03%3A18.265Z";
            URL apiUrl = new URL(url);
            HttpURLConnection connection = (HttpURLConnection) apiUrl.openConnection();
            connection.setRequestMethod("GET");
            connection.setRequestProperty("accept", "text/plain");
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", "76591d32138f4f60b580db9ec9167f1d");
            connection.setRequestProperty("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04");
      
            int responseCode = connection.getResponseCode();
            BufferedReader reader;
            if (responseCode == HttpURLConnection.HTTP_OK) {
                reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
            } else {
                reader = new BufferedReader(new InputStreamReader(connection.getErrorStream()));
            }
      
            StringBuilder response = new StringBuilder();
            String line;
            while ((line = reader.readLine()) != null) {
                response.append(line);
            }
            reader.close();
      
            System.out.println("Response Body: " + response.toString());
        } catch (Exception e) {
            e.printStackTrace();
        }
    }
}`
    },
    "C#": {
      "request": `using System;
using System.Net.Http;
using System.Threading.Tasks;
      
public class Program
{
    public static async Task Main(string[] args)
    {
        string url = "https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/transactionReport?StartDate=2023-06-28T00%3A03%3A18.265Z&EndDate=2023-06-28T05%3A03%3A18.265Z";
        string bearerToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        string ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
        using (HttpClient client = new HttpClient())
        {
            client.DefaultRequestHeaders.Add("accept", "text/plain");
            client.DefaultRequestHeaders.Add("Authorization", $"Bearer {bearerToken}");
            client.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
      
            HttpResponseMessage response = await client.GetAsync(url);
      
            if (response.IsSuccessStatusCode)
            {
                string responseBody = await response.Content.ReadAsStringAsync();
                Console.WriteLine("Response Body: " + responseBody);
            }
            else
            {
                Console.WriteLine("Request failed with status code: " + response.StatusCode);
            }
        }
    }
}`
    },
    "python": {
      "request": `import requests

url = 'https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/transactionReport'
params = {
    'StartDate': '2023-06-28T00:03:18.265Z',
    'EndDate': '2023-06-28T05:03:18.265Z'
}
headers = {
    'accept': 'text/plain',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
    'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d'
}
      
response = requests.get(url, params=params, headers=headers)
      
if response.status_code == 200:
    response_data = response.json()
    print("Response Body:", response_data)
else:
    print("Request failed with status code:", response.status_code)`
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');

const url = 'https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/transactionReport';
const startDate = '2023-06-28T00:03:18.265Z';
const endDate = '2023-06-28T05:03:18.265Z';
const headers = {
  'accept': 'text/plain',
  'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
  'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d'
};
      
axios.get(url, {
  params: {
    StartDate: startDate,
    EndDate: endDate
  },
  headers: headers
})
  .then(response => {
    console.log('Response Body:', response.data);
  })
  .catch(error => {
    console.log('Request failed with error:', error);
  });`
    }
  };

export const transactionReportCodeResponse = `{
  "transactionList": [
    {
      "transDate": "2024-10-15T08:06:19.9",
      "transactionType": 1,
      "amount": 0,
      "extra": 0,
      "cashBack": 0,
      "reference": "string",
      "authCode": "string",
      "hostResponse": "string",
      "institution": "string",
      "batch": null,
      "cardName": "string"
    },
    {
      "transDate": "2024-10-15T08:06:46.8",
      "transactionType": 1,
      "amount": 0,
      "extra": 0,
      "cashBack": 0,
      "reference": "string",
      "authCode": "string",
      "hostResponse": "string",
      "institution": "string",
      "batch": null,
      "cardName": "string"
    }
  ]
}`;  
  

  